<template>
    <div>

    </div>
</template>

<script>

    export default {
        name: 'app',
        data() {
            return {
                tableData: [{
                    id: 1,
                    date: '2016-05-02',
                    name: '王小虎',
                    address: '上海市普陀区金沙江路 1518 弄',
                    parentId:0,
                    children: [

                    ],
                },
                    {
                    id: 2,
                    date: '2016-05-04',
                    name: '王小虎',
                    parentId:0,
                    address: '上海市普陀区金沙江路 1517 弄',
                    children: [],
                }, {
                    id: 3,
                    date: '2016-05-01',
                    name: '王小虎',
                    parentId:0,
                    address: '上海市普陀区金沙江路 1519 弄',
                    children: [{
                        id: 31,
                        address: '上海市普陀区金沙江路 1519 弄'
                    }, {
                        id: 32,
                        address: '上海市普陀区金沙江路 1519 弄'
                    }]
                }, {
                    id: 4,
                    date: '2016-05-03',
                    name: '王小虎',
                    address: '上海市普陀区金沙江路 1516 弄',
                    parentId:0,
                    children: [{
                        id: 35,
                        
                        address: '上海市普陀区金沙江路 1519 弄'
                    }],
                }
                ],
                maxIndex:0,


            }
        },
        methods: {
            handleAdd(index,row){
                this.maxIndex +=1;
                row.children.push({
                    id: this.maxIndex,
                    
                    address: '陕西省西安市雁塔区'
                });
            },
            handleDelete(index,row){
                console.log("index = ",index)
                console.log("row = ",row)
                this.deleteRowById(this.tableData,row.id);
            },


           /**
            * 根据ID ，递归删除数组中ID值相同的对象
            * @param list 被移除的原数组
            * @param id 根据ID值查询对应数据所在位置
            * */
            deleteRowById(list,id){
               if(!list || list.length <= 0){
                   return;
               }
               for (let i = 0; i < list.length; i++) {
                   if(list[i].id === id){
                       list.splice(i,1);
                   }
                   if(list.length <= 0 || undefined === list[i] ||undefined === list[i].children ){
                       continue;
                   }
                   this.deleteRowById(list[i].children,id)
               }
            },


            /**
             * 找出数组中最大的ID，仅用于列表组件使用，不传递给后台
             * @param list
             */
            getTableDateMaxId(list){
                if(!list || list.length <= 0){
                    return;
                }
                for (let i = 0; i < list.length; i++) {
                    if(list[i].id > this.maxIndex){
                        this.maxIndex = list[i].id;
                    }
                    this.getTableDateMaxId(list[i].children)
                }
            }

        },
        mounted() {
            this.getTableDateMaxId(this.tableData);
        }
    }
</script>

<style scoped>
    .foot {
        position: fixed;
        left: 0;
        bottom: 0;
        width: 100%;
        background: #333;
        padding: 24px;
        overflow: hidden;
        color: #999;
        font-size: 14px;
        text-align: center;
    }

    .foot a {
        color: #fff;
        margin: 0 .5em
    }
</style>
